import { AppServerErrorModel } from "../../model"


export class AppUnauthorizedError extends Error {
    errData: AppServerErrorModel

    constructor(data: AppServerErrorModel) {
        super(data.message)

        this.errData = data
    }
}